module.exports = __webpack_public_path__ + "img/terms-conditions-d.1006573.webp";